import { render } from "./index.vue?vue&type=template&id=fae93588&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fae93588&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fae93588"

export default script